import React from "react";
import {
  message,
  Space,
  Tooltip,
  Modal,
  Button,
  Image,
  Row,
  Col,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import DriverBehaviourSettingStore from "../store/DriverBehaviourSettingStore";

import { Link } from "react-router-dom";
import withRouter from "../withRouter";

import ListTable from "./ListTable";

import DriverBehaviourSettingsAdd from "./DriverBehaviourSettingsAdd";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import { CloseOutlined } from "@ant-design/icons";

class CompanyDriverBehaviourSetting extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.driverBehaviorStore = new DriverBehaviourSettingStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      offset: 0,
      limit: 50,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      openDriverBehaviourForm: false,
      driverBehaviourId: "",
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Account",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
        dataIndex: "company",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Min. Mileage(km)",
        title: context.translate("_Min_Mileage_"),
        dataIndex: "minMileage",
        width: 13,

        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            return <>{value} Km</>;
          } else {
            return " ";
          }
        },
      },
      {
        // title: "Top Score",
        title: context.translate("_TOP_SCORE_"),
        dataIndex: "topScore",
        width: 13,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Absolute Value",
        title: context.translate("_ABSOLUTE_VAL_"),
        dataIndex: "absValue",
        width: 13,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == 0 || value == null) {
            return "OFF";
          } else {
            return "ON";
          }
        },
      },
      {
        // title: "User Customized Score",
        title: context.translate("_USER_COSTIMIZED_SCORE_"),
        dataIndex: "custScore",
        width: 17,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == 0 || value == null) {
            return "OFF";
          } else {
            return "ON";
          }
        },
      },
      {
        // title: "Harsh Accel",
        title: context.translate("_HARSH_ACCEL_"),
        dataIndex: "harshAcce",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return <>{value}%</>;
        },
      },
      {
        // title: "Harsh Braking",
        title: context.translate("_HARSH_BRACKING_"),
        dataIndex: "harshBrack",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return <>{value}%</>;
        },
      },
      {
        // title: "EX-idling",
        title: context.translate("_EX_IDELING_"),
        dataIndex: "exIdeling",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return <>{value}%</>;
        },
      },
      {
        // title: "Speeding",
        title: context.translate("_SPEEDING_"),
        dataIndex: "speeding",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return <>{value}%</>;
        },
      },
      {
        // title: "SeatBelt",
        title: context.translate("_RPM_EXCESS_"),
        dataIndex: "rpmExcess",
        width: 12,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return <>{value}%</>;
        },
      },
      {
        // title: "SeatBelt",
        title: context.translate("_FLEET_DASHBORD_SETTING_SEATBELT_"),
        dataIndex: "seatBelt",
        width: 8,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return <>{value}%</>;
        },
      },
      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        width: 7,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={this.context.translate("_EDIT_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: "19px",
                      width: "14px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                </Tooltip>

                <Tooltip
                  title={this.context.translate("_DELETE_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/Delete.png")}
                    style={{ cursor: "pointer" ,
                      width: "14px"}}
                    onClick={() =>
                      this.setState({
                        openDeleteModal: true,
                        deleteData: record,
                      })
                    }
                  ></Image>
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    await this.setState({ driverBehaviourId: record.id });
    await this.setState({ openDriverBehaviourForm: true });
  };
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    await this.driverBehaviorStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (Number(this.props.getUserData().isadmin) === 0) {
      this.props.navigate("/login");
    }
  }
  async onDelete(record) {
    const response =
      await this.driverBehaviorStore.deleteDriverBehaviourSetting({
        id: record.id,
      });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  async handleSearch() {
    this.setState({ loading: true });
    await this.driverBehaviorStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  responseMsg = async (obj) => {
    const { userCustomizedScoreShow, total, response } = obj;

    if (!userCustomizedScoreShow) {
      if (response?.success === "S") {
        message.success(response.message);
        await this.driverBehaviorStore.loadData({ offset: 0, limit: 50 });
        await this.setState({ openDriverBehaviourForm: false });
      } else {
        message.error(response.message);
      }
    } else {
      if (total !== 100) {
        message.error("Kindly check Total %, Total should be 100%");
      } else {
        if (response?.success === "S") {
          message.success(response.message);
          await this.driverBehaviorStore.loadData({ offset: 0, limit: 50 });
          await this.setState({ openDriverBehaviourForm: false });

          // this.props.navigate("/companydriverbehaviorsetting");
        } else {
          message.error(response.message);
        }
      }
    }
  };

  closeModal = () => {
    this.setState({ openDriverBehaviourForm: false, userId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });

    await this.driverBehaviorStore.loadData({
      offset: 0,
      limit: 50,
    });

    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}></Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({
                      driverBehaviourId: "",
                      openDriverBehaviourForm: true,
                    })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              </Space>
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.driverBehaviorStore?.total}
            columns={this.columns}
            dataSource={this.driverBehaviorStore?.driverBehavior}
            loading={this.driverBehaviorStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openDriverBehaviourForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openDriverBehaviourForm}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_DRIVER_BEHAVIOR_SETTINGS_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_BEHAVIOUR_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openDriverBehaviourForm: false })}
            onCancel={() =>
              this.setState({
                openDriverBehaviourForm: false,
                driverBehaviourId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <DriverBehaviourSettingsAdd
                driverBehaviourId={this.state.driverBehaviourId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
CompanyDriverBehaviourSetting.contextType = StoreContext;
export default observer(withRouter(CompanyDriverBehaviourSetting));
